import { Box, Typography } from '@mui/material'
import { founderImage, foundersMessageParagraphs } from '../../data/aboutContent'

export default function FoundersMessageSection() {
  return (
    <Box
      component="section"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: { xs: 3, md: '40px' },
      }}
    >
      <Typography
        component="h2"
        sx={{
          fontSize: { xs: 22, md: 22 },
          lineHeight: 'normal',
          fontWeight: 400,
          color: '#111',
          textTransform: 'capitalize',
        }}
      >
        Founder&apos;s Message
      </Typography>

      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          gap: { xs: 4, md: 6, lg: '50px' },
          alignItems: { md: 'center' },
        }}
      >
        <Box
          sx={{
            width: { xs: '100%', md: 400, lg: 543 },
            maxWidth: { md: 400, lg: 543 },
            height: { xs: 400, sm: 500, md: 520, lg: 684 },
            flexShrink: 0,
            borderRadius: '20px',
            overflow: 'hidden',
            bgcolor: '#fffefa',
          }}
        >
          <Box
            component="img"
            src={founderImage}
            alt="Founder"
            sx={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              display: 'block',
            }}
          />
        </Box>

        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: 4, md: '51px' },
            justifyContent: 'center',
            minHeight: { md: 520, lg: 684 },
          }}
        >
          {foundersMessageParagraphs.map((paragraph) => (
            <Typography
              key={paragraph.slice(0, 40)}
              sx={{
                fontSize: { xs: 18, sm: 24, md: 30, lg: 30 },
                lineHeight: 'normal',
                fontWeight: 400,
                color: '#000',
              }}
            >
              {paragraph}
            </Typography>
          ))}
        </Box>
      </Box>
    </Box>
  )
}
